import { getAllUrlParams, getUrlParams } from '../utils/get-url-params';
import { MetodoPagamentoVendaEnum } from '../types/enums/metodo-pagamento.enum';
import { removeMask } from '../utils/remove-mask';
import { resetTimer } from '../redux/slices/pix-timer.slice';
import { emitFacebookEvent } from '../utils/emit-facebook-event';
import { emitUtmifyEvent } from '../utils/emitUtmifyEvent';

export const pixStrategy = async ({
  data,
  checkout,
  id,
  api,
  gerarTokenRecaptcha,
  navigate,
  location,
  dispatch,
}: any) => {
  const recaptcha = await gerarTokenRecaptcha(`/venda`);
  const afiliadoId = getUrlParams('affiliate') ?? undefined;

  const purchase = await api.Venda.createPix({
    metodoPagamento: MetodoPagamentoVendaEnum.PIX,
    produtoId: id ?? '',
    emailComprador: data.email,
    nomeComprador: data.fullName,
    sobrenomeComprador: data.fullName,
    cpfComprador: removeMask(data.cpf),
    telefoneComprador: removeMask(data.phoneNumber),
    checkoutId: checkout?.id,
    recaptchaToken: recaptcha,
    postalCode: data?.postalCode,
    state: data?.state,
    city: data?.city,
    district: data?.neighborhood,
    address: data?.address,
    number: data?.number,
    complement: data?.complement,
    afiliadoId,
    utmSource: getUrlParams('utm_source'),
    utmCampaign: getUrlParams('utm_campaign'),
    utmMedium: getUrlParams('utm_medium'),
    utmContent: getUrlParams('utm_content'),
    utmTerm: getUrlParams('utm_term'),
    sck: getUrlParams('sck') ?? undefined,
    src: getUrlParams('src') ?? undefined,
    urlParams: getAllUrlParams(),
  });

  dispatch(resetTimer());
  if (checkout?.produto?.purchaseNoPix) {
    emitFacebookEvent({ event: 'Purchase', data, checkout });
  }
  emitFacebookEvent({ event: 'GeneratePix', data, checkout });
  emitUtmifyEvent({
    event: 'waiting_payment',
    vendaId: purchase.data?.id,
  });

  const params = new URLSearchParams(location.search);
  navigate(`/venda/pix?${params?.toString()}`, {
    state: { purchase, checkout },
  });
};
